@let liveVideoVisible = voiceControlMode === 'video' && liveActive && liveMediaStream();
<div class="relative flex flex-col flex-1 min-h-0">
<div #chat class="relative z-10 flex flex-col flex-1 min-h-0 overflow-y-auto gap-y-4"
     [ngClass]="{ 'mt-auto max-h-[25%] px-4': liveVideoVisible }">
  @for (msg of messageHistory; track msg) {
    <div #messageItem class="flex flex-col">
      @if (msg.type === CosoMessageType.AI) {
        <!-- Row with status, tools, timestamp -->
        @let isStreamingMessage = loading && messageHistory.indexOf(msg) === messageHistory.length - 1;
        @let isLastMessage = messageHistory.indexOf(msg) === messageHistory.length - 1;
        <div class="flex flex-row items-center justify-between gap-x-3 w-full">
          <div class="flex min-w-0 flex-1">
            @if (isStreamingMessage) {
              <div class="flex min-w-0 flex-row gap-x-3 items-center py-2">
                <!--<p-avatar image="assets/COSO-avatar-light.png" shape="circle" size="large"
                          class="text-xs! animate-pulse min-w-7"/>-->
                <img src="assets/COSO-avatar-light-64x64.png"
                     class="block dark:hidden animate-pulse"
                     height="48" width="48"
                     alt="Avatar"/>
                <img src="assets/COSO-avatar-dark-64x64.png"
                     class="hidden dark:block animate-pulse"
                     height="48" width="48"
                     alt="Avatar"/>
                <span
                  class="min-w-0 truncate text-xs text-gray-500 animate-pulse">{{ getReasoningPreview(msg) || (environment.COSO_NAME + ' is thinking...') }}</span>
              </div>
            } @else if (msg.toolCalls?.length) {
              <div class="flex flex-row flex-wrap gap-y-1 gap-x-2">
                @for (toolCall of msg.toolCalls; track toolCall) {
                  @let severity = toolCall.hasOwnProperty('status') && toolCall.status !== 'success' ? 'danger' : 'success';
                  <p-tag [severity]="severity" class="cursor-pointer"
                         [class.animate-pulse]="!toolCall.hasOwnProperty('result') && isStreamingMessage"
                         [pTooltip]="toolCall.toolName + '\n' + JSON.stringify(toolCall.toolArgs,null,2)"
                         tooltipPosition="top"
                         tooltipStyleClass="text-sm" showDelay="500"
                         (click)="copyToolData(toolCall.toolArgs)">
                    <div class="flex flex-row items-center">
                      @if (toolCall.toolName === "SQL-Search") {
                        <i class="pi pi-database"></i>
                      } @else if (toolCall.toolName === "fm-search") {
                          <i class="pi pi-server"></i>
                      } @else if (toolCall.toolName === "Chart-Config") {
                        <i class="pi pi-chart-line"></i>
                      } @else if (toolCall.toolName === "Google-Search") {
                        <i class="pi pi-google"></i>
                      } @else if (toolCall.toolName === "Fetch-Page") {
                        <i class="pi pi-link"></i>
                      } @else if (toolCall.toolName === "Generate-Image") {
                        <i class="pi pi-image"></i>
                      } @else if (toolCall.toolName === "PDF-Generation") {
                        <i class="pi pi-file-pdf"></i>
                      } @else {
                        <i class="pi pi-copy"></i>
                      }
                    </div>
                  </p-tag>
                }
              </div>
            }
          </div>
          @if ((isStreamingMessage && msg.toolCalls?.length) || !loading || msg.reasoning?.length || shouldShowSpeechControl(msg, isLastMessage, isStreamingMessage)) {
            <div class="flex flex-row flex-wrap items-center justify-end gap-y-1 gap-x-2">
              @if (isStreamingMessage && msg.toolCalls?.length) {
                <div class="flex flex-row flex-wrap justify-end gap-y-1 gap-x-2">
                  @for (toolCall of msg.toolCalls; track toolCall) {
                    @let severity = toolCall.hasOwnProperty('status') && toolCall.status !== 'success' ? 'danger' : 'success';
                    <p-tag [severity]="severity" class="cursor-pointer"
                           [class.animate-pulse]="!toolCall.hasOwnProperty('result') && isStreamingMessage"
                           [pTooltip]="toolCall.toolName + '\n' + JSON.stringify(toolCall.toolArgs,null,2)"
                           tooltipPosition="top"
                           tooltipStyleClass="text-sm" showDelay="500"
                           (click)="copyToolData(toolCall.toolArgs)">
                      <div class="flex flex-row items-center">
                        @if (toolCall.toolName === "SQL-Search") {
                          <i class="pi pi-database"></i>
                        } @else if (toolCall.toolName === "fm-search") {
                            <i class="pi pi-server"></i>
                        } @else if (toolCall.toolName === "Chart-Config") {
                          <i class="pi pi-chart-line"></i>
                        } @else if (toolCall.toolName === "Google-Search") {
                          <i class="pi pi-google"></i>
                        } @else if (toolCall.toolName === "Fetch-Page") {
                          <i class="pi pi-link"></i>
                        } @else if (toolCall.toolName === "Generate-Image") {
                          <i class="pi pi-image"></i>
                        } @else if (toolCall.toolName === "PDF-Generation") {
                          <i class="pi pi-file-pdf"></i>
                        } @else {
                          <i class="pi pi-copy"></i>
                        }
                      </div>
                    </p-tag>
                  }
                </div>
              }
              @if (!loading || msg.reasoning?.length) {
                <div class="flex items-center gap-x-2">
                  @if (!loading) {
                    <span class="text-xs text-gray-500">{{ msg.date | date: 'dd/MM/yyyy HH:mm' }}</span>
                  }
                  @if (msg.reasoning?.length && environment.FEATURE_FLAGS.coso.display_reasoning) {
                    <button type="button"
                            class="flex items-center justify-center appearance-none border-0 bg-transparent p-1 text-gray-500 hover:invert transition duration-300 cursor-pointer"
                            [attr.aria-label]="isReasoningPanelCollapsed(msg) ? 'Show reasoning' : 'Hide reasoning'"
                            [attr.aria-expanded]="!isReasoningPanelCollapsed(msg)"
                            [pTooltip]="isReasoningPanelCollapsed(msg) ? 'Show reasoning' : 'Hide reasoning'"
                            tooltipPosition="bottom"
                            tooltipStyleClass="text-sm"
                            (click)="toggleReasoningPanel(msg)">
                      <p-tag severity="info" class="cursor-pointer pr-0.75!" [class.animate-pulse]="isStreamingMessage">
                        <div class="flex flex-row items-center">
                          <i class="pi pi-microchip-ai"></i>
                        </div>
                      </p-tag>
                    </button>
                  }
                </div>
              }
              @if (shouldShowSpeechControl(msg, isLastMessage, isStreamingMessage)) {
                <button type="button"
                        class="flex items-center justify-center appearance-none border-0 bg-transparent p-1 text-gray-500 hover:invert transition duration-300 cursor-pointer"
                        [attr.aria-label]="speaking ? 'Stop speech' : 'Play speech'"
                        [pTooltip]="speaking ? 'Stop speech' : 'Play speech'"
                        tooltipPosition="bottom"
                        tooltipStyleClass="text-sm"
                        (click)="speaking ? stopSpeech() : playSpeech(msg)">
                  <i [ngClass]="speaking ? 'pi pi-volume-up animate-pulse' : 'pi pi-play'"></i>
                </button>
              }
              @if (!loading && !msg.welcomeMsg) {
                <button type="button"
                        class="flex items-center justify-center appearance-none border-0 bg-transparent p-1 text-gray-500 hover:invert transition duration-300 cursor-pointer"
                        aria-label="Message actions"
                        pTooltip="Message actions"
                        tooltipPosition="bottom"
                        tooltipStyleClass="text-sm"
                        (click)="messageActionsMenu.toggle($event)">
                  <i class="pi pi-ellipsis-v"></i>
                </button>
                <p-menu #messageActionsMenu [model]="getMessageActionItems(msg)" [popup]="true" appendTo="body"/>
              }
            </div>
          }
        </div>
        <!-- Reasoning -->
        @if (msg.reasoning?.length && environment.FEATURE_FLAGS.coso.display_reasoning) {
          <div class="w-full">
            <p-panel [toggleable]="true"
                     [showHeader]="false"
                     [collapsed]="isReasoningPanelCollapsed(msg)"
                     (collapsedChange)="setReasoningPanelCollapsed(msg, $event)"
                     class="w-full border-0! mt-4">
              <div
                class="prose dark:prose-invert w-full max-w-none rounded-md border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 px-4 py-3 text-sm">
                <markdown [data]="getReasoningMarkdown(msg)"></markdown>
              </div>
            </p-panel>
          </div>
        }
        <!-- Interrupts -->
        <div class="flex flex-col w-full">
          @if (msg.interrupts?.length) {
            @for (interrupt of msg.interrupts; track interrupt.id) {
              @for (actionRequest of interrupt.actionRequests; track actionRequest) {
                <p-panel [header]="getActionRequestHeader(actionRequest)" class="mt-4">
                  @if (actionRequest.display?.title || actionRequest.display?.summary) {
                    <div class="mb-4">
                      @if (actionRequest.display?.title) {
                        <p class="m-0 text-sm font-semibold text-gray-800 dark:text-gray-100">{{ actionRequest.display?.title }}</p>
                      }
                      @if (actionRequest.display?.summary) {
                        <p class="m-0 mt-1 text-sm text-gray-600 dark:text-gray-300">{{ actionRequest.display?.summary }}</p>
                      }
                    </div>
                  }
                  <dl class="m-0 grid gap-3">
                    @for (field of getActionRequestFields(actionRequest); track field.label) {
                      <div class="grid gap-1 sm:grid-cols-[9rem_minmax(0,1fr)] sm:gap-3">
                        <dt class="text-sm font-medium text-gray-600 dark:text-gray-300">{{ field.label }}</dt>
                        <dd class="m-0 min-w-0 text-sm text-gray-900 dark:text-gray-100">
                          @if (isUrlActionRequestField(field)) {
                            <a [href]="field.value" target="_blank" rel="noopener noreferrer" class="break-all text-primary hover:underline">{{ field.value }}</a>
                          } @else if (isSimpleActionRequestValue(field.value)) {
                            <span class="break-words">{{ formatActionRequestValue(field.value) }}</span>
                          } @else {
                            <pre class="m-0 max-h-60 overflow-auto whitespace-pre-wrap break-words rounded border border-gray-200 bg-gray-50 p-3 text-xs text-gray-800 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100">{{ formatActionRequestValue(field.value) }}</pre>
                          }
                        </dd>
                      </div>
                    }
                  </dl>
                  <div class="flex flex-row items-center gap-x-4 mt-6">
                    @if (actionRequest.decision) {
                      @if (actionRequest.decision === CosoDecisionType.APPROVE) {
                        <p class="m-0 italic text-green-500">You approved this decision</p>
                      } @else {
                        <p class="m-0 italic text-red-500">You rejected this decision</p>
                      }
                    } @else {
                      @if (actionRequest.allowedDecisions.includes(CosoDecisionType.APPROVE)) {
                        <p-button label="Approve" icon="pi pi-check" severity="success"
                                  size="small"
                                  (click)="approveActionRequest(actionRequest)"/>
                      }
                      @if (actionRequest.allowedDecisions.includes(CosoDecisionType.REJECT)) {
                        <p-button label="Reject" icon="pi pi-times" severity="danger"
                                  size="small"
                                  (click)="rejectActionRequest(actionRequest)"/>
                      }
                    }
                  </div>
                </p-panel>
              }
            }
          }
        </div>

        <!-- AI Message content -->
        <div class="prose w-fit max-w-full"
             [ngClass]="liveVideoVisible ? 'prose-invert bg-black/50 backdrop-blur-sm rounded-lg px-3 py-2' : 'dark:prose-invert'">
          <markdown [data]="msg.content"></markdown>
        </div>

        <!-- Charts -->
        @if (msg.toolCalls?.length) {
          <div class="flex flex-col w-full gap-4 mt-4">
            @for (toolCall of msg.toolCalls; track toolCall.id) {
              @if (toolCall.toolName === 'Chart-Config' && toolCall.result) {
                @let chartConfig = getChartConfig(toolCall);
                @if (chartConfig) {
                  <p-chart [type]="chartConfig.type" [data]="chartConfig.data"
                           [options]="chartConfig.options"
                           class="h-[22rem] w-full"/>
                }
              }
              @if (isGeneratedImage(toolCall)) {
                <div class="flex flex-col items-start gap-2">
                  @let imageUrl = getGeneratedImageUrl(toolCall);
                  @if (imageUrl) {
                    <img [src]="imageUrl"
                         [alt]="toolCall.artifact.generatedImage!.filename"
                         class="max-h-96 max-w-full rounded-md border border-gray-300 dark:border-gray-600"/>
                  } @else {
                    <span class="text-sm text-gray-500">Loading generated image...</span>
                  }
                  <a href=""
                     class="not-prose inline-flex max-w-full items-center gap-1.5 rounded-full border border-blue-200 bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700 no-underline transition-colors hover:bg-blue-200 dark:border-blue-400/40 dark:bg-blue-500/15 dark:text-blue-200 dark:hover:bg-blue-500/25"
                     pTooltip="Download generated image"
                     tooltipPosition="bottom"
                     tooltipStyleClass="text-sm"
                     (click)="$event.preventDefault(); downloadGeneratedImage(toolCall)">
                    <i class="pi pi-image text-[10px]" aria-hidden="true"></i>
                    <span class="max-w-64 truncate">{{ toolCall.artifact.generatedImage!.filename }}</span>
                  </a>
                </div>
              }
              @if (isGeneratedPdf(toolCall)) {
                <div class="flex flex-col items-start gap-2">
                  <a href=""
                     class="not-prose inline-flex max-w-full items-center gap-1.5 rounded-full border border-blue-200 bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700 no-underline transition-colors hover:bg-blue-200 dark:border-blue-400/40 dark:bg-blue-500/15 dark:text-blue-200 dark:hover:bg-blue-500/25"
                     pTooltip="Download generated PDF"
                     tooltipPosition="bottom"
                     tooltipStyleClass="text-sm"
                     (click)="$event.preventDefault(); downloadGeneratedPdf(toolCall)">
                    <i class="pi pi-file-pdf text-[10px]" aria-hidden="true"></i>
                    <span class="max-w-64 truncate">{{ toolCall.artifact.generatedPdf!.filename }}</span>
                  </a>
                </div>
              }
            }
          </div>
        }

        @if (msg.errors?.length) {
          @for (error of msg.errors; track error) {
            <div class="flex flex-row gap-x-1 items-center text-red-700">
              <i class="pi pi-exclamation-circle"></i>
              <span class="italic" tooltipStyleClass="text-sm"
                    [pTooltip]="msg.content" tooltipPosition="bottom">
                                {{ error.content }}
                            </span>
            </div>
          }
        }
      } @else if (msg.type === CosoMessageType.HUMAN) {
        @if (msg.summarization) {
          <div class="flex flex-row gap-x-1 items-center">
            <i class="pi pi-info-circle"></i>
            <span class="italic" tooltipStyleClass="text-sm"
                  [pTooltip]="msg.content" tooltipPosition="bottom">
                                The chat content has been summarized.
                            </span>
          </div>
        } @else {
          <!-- Human message -->
          <div #humanMessageItem
               class="w-fit max-w-full self-end border rounded-lg py-2 px-4"
               [ngClass]="liveVideoVisible ? 'bg-sky-950/50 backdrop-blur-sm text-sky-200 border-sky-300/30' : 'bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600'">
            <div class="flex flex-row items-center justify-between gap-x-3 text-xs text-gray-400 mb-1">
              <span>{{ msg.date | date: 'dd/MM/yyyy HH:mm' }}</span>
              <button type="button"
                      class="flex items-center justify-center appearance-none border-0 bg-transparent p-1 text-gray-500 hover:invert transition duration-300 cursor-pointer"
                      aria-label="Save prompt"
                      pTooltip="Save prompt"
                      tooltipPosition="bottom"
                      tooltipStyleClass="text-sm"
                      (click)="openCosoPromptDialogForMessage(msg)">
                <i class="pi pi-save"></i>
              </button>
            </div>
            @if (msg.files?.length) {
              <div class="flex flex-row flex-nowrap gap-3 overflow-x-auto overflow-y-visible pr-4 py-4">
                @for (file of msg.files; track file.fileName + $index) {
                  <div class="relative inline-block">
                    @if (file.type === CosoFileType.IMAGE) {
                      <img [src]="getAttachmentPreviewUrl(file)" alt="Message attachment"
                           class="w-16 h-16 object-cover rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 shadow-sm">
                    } @else if (file.type === CosoFileType.AUDIO) {
                      <audio [src]="getAttachmentPreviewUrl(file)" controls class="w-48"></audio>
                    } @else if (file.type === CosoFileType.VIDEO) {
                      <video [src]="getAttachmentPreviewUrl(file)" controls
                             class="w-32 h-20 object-cover rounded-md border border-gray-300 dark:border-gray-600 bg-black"></video>
                    } @else {
                      <div class="flex flex-col items-center justify-center gap-y-1">
                        <i class="pi text-gray-500" [class]="getFileIcon(file)"
                           style="font-size: 2rem"></i>
                        <span class="text-xs">{{ file.fileName }}</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div class="coso-human-message-content prose max-w-full text-base"
                 [ngClass]="liveVideoVisible ? 'prose-invert' : 'dark:prose-invert'"
                 [innerHTML]="(msg.content ?? '') | markdown: humanMessageMarkdownOptions | async"></div>
          </div>
        }
      }
    </div>
  }
  <div class="scroll-spacer flex-none" [style.height.px]="bottomSpacerHeight"></div>
</div>
  @if (liveVideoVisible) {
    <video [srcObject]="liveMediaStream()"
           [muted]="true"
           autoplay
           playsinline
           class="pointer-events-none absolute inset-0 z-0 h-full w-full rounded-md bg-black object-cover">
    </video>
    <button type="button"
            class="absolute top-3 right-3 z-20 flex items-center justify-center rounded-full border-0 bg-black/50 p-2 text-white backdrop-blur-sm cursor-pointer"
            aria-label="Switch camera"
            pTooltip="Switch camera" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500"
            (click)="switchCamera()">
      <span class="material-icons">cameraswitch</span>
    </button>
  }
</div>
<!-- bottom area -->
<div class="">
  <div #prompt class="flex flex-row gap-x-2 items-center w-full" [class.hidden]="liveActive">
    <div class="flex flex-col flex-grow pt-3">
      <div class="relative w-full">
          <button type="button"
                  class="md:mt-[0.4rem] absolute left-2 appearance-none border-0 bg-transparent p-1 text-gray-500 transition duration-300 controls-button-size"
                  [ngClass]="loading || cosoPromptsLoading || !cosoPromptOptions.length ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:invert'"
                  [disabled]="loading || cosoPromptsLoading || !cosoPromptOptions.length"
                  [pTooltip]="cosoPromptsLoading ? 'Loading prompts' : (cosoPromptOptions.length ? 'Select prompt' : 'No saved prompts')"
                  tooltipPosition="left"
                  tooltipStyleClass="text-sm"
                  showDelay="500"
                  aria-label="Select prompt"
                  (click)="cosoPromptPopover.toggle($event)">
            <i class="pi pi-ellipsis-v"></i>
          </button>
          <p-popover #cosoPromptPopover>
            <div class="flex w-[calc(100vw-3rem)] md:w-160 flex-col gap-2 p-3">
              <input type="text"
                     pInputText
                     pSize="small"
                     [(ngModel)]="cosoPromptSearchQuery"
                     placeholder="Search prompts"
                     class="w-full placeholder:text-sm"/>
              <div class="min-h-80 max-h-80 overflow-y-auto">
                @for (group of getFilteredCosoPromptGroups(); track group.category ?? '') {
                    <p-tag class="truncate text-xs! font-normal!" size="small" severity="secondary">{{ group.category || 'no category' }}</p-tag>
                  @for (prompt of group.prompts; track prompt.coso_prompts_id) {
                    <button type="button"
                            class="flex w-full min-w-0 flex-col items-start gap-0.5 rounded px-3 py-2 text-left hover:bg-surface-100 dark:hover:bg-surface-800"
                            (click)="applyCosoPrompt(prompt); cosoPromptPopover.hide()">
                      <span class="w-full truncate text-sm">{{ prompt.title }}</span>
                    </button>
                  }
                } @empty {
                  <div class="px-3 py-2 text-sm text-gray-400">No prompts found</div>
                }
              </div>
            </div>
          </p-popover>
        <!-- Prompt input -->
          <div> <!--text area wrapper -->
              <textarea pTextarea [(ngModel)]="chatInputMessage" rows="1" [autoResize]="true"
                        variant="filled" class="w-full px-10! py-4!" [placeholder]="getChatInputPlaceholder()"
                        [disabled]="loading || uploadingAttachments"
                        [class.pt-28!]="attachedFiles.length"
                        (keydown)="onKeyDown($event)"></textarea>
              <!-- Prompt images -->
              @if (attachedFiles.length) {
                  <div class="absolute left-4 right-4 top-4 pointer-events-auto">
                      <div class="flex flex-row flex-nowrap gap-3 overflow-x-auto overflow-y-visible pr-4 pt-2">
                          @for (file of attachedFiles; track file.previewUrl; let idx = $index) {
                              <div class="relative inline-block">
                                  @if (file.type === CosoFileType.IMAGE) {
                                      <img [src]="file.previewUrl" alt="Selected attachment"
                                           class="w-16 h-16 object-cover rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 shadow-sm">
                                  } @else if (file.type === CosoFileType.AUDIO) {
                                      <audio [src]="file.previewUrl" controls class="w-48"></audio>
                                  } @else if (file.type === CosoFileType.VIDEO) {
                                      <video [src]="file.previewUrl" controls
                                             class="w-32 h-20 object-cover rounded-md border border-gray-300 dark:border-gray-600 bg-black"></video>
                                  } @else {
                                      <div class="flex flex-col items-center justify-center gap-y-1">
                                          <i class="pi text-gray-500" [class]="getFileIcon(file)"
                                             style="font-size: 2rem"></i>
                                          <span class="text-xs">{{ file.fileName }}</span>
                                      </div>
                                  }
                                  <button type="button"
                                          class="absolute -top-2 -right-2 bg-gray-500 text-white hover:invert dark:hover:text-red-600! dark:bg-gray-200 dark:text-gray-900 rounded-full w-5 h-5 flex items-center justify-center text-[10px] shadow cursor-pointer"
                                          (click)="removeAttachedFile(idx)" aria-label="Remove attached image">
                                      <i class="pi pi-times-circle"></i>
                                  </button>
                              </div>
                          }
                      </div>
                  </div>
              }
              <!-- Send message button -->
              @if (streamingResponse) {
                  <button type="button"
                          class="absolute right-1 bottom-[0.2rem] appearance-none border-0 bg-transparent p-1 text-gray-300 hover:invert transition duration-300 cursor-pointer"
                          pTooltip="Stop response" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500"
                          (click)="stopCosoResponse()">
                      <i class="material-icons animate-pulse" style="font-size: 36px">stop_circle</i>
                  </button>
              } @else {
                  <button type="button"
                          class="absolute right-1 bottom-2 appearance-none border-0 bg-transparent p-1 text-gray-400 transition duration-300"
                          [ngClass]="canSendHumanMessage() ? 'cursor-pointer text-gray-500 hover:text-green-600!' : 'cursor-not-allowed'"
                          [disabled]="!canSendHumanMessage()"
                          pTooltip="Send Message" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="1000"
                          (click)="sendHumanMessage()">
                      <i class="material-icons ">keyboard_return</i>
                  </button>
              }
          </div>
      </div>
    </div>
  </div>
  <!-- Controls Footer -->
  <div class="flex flex-row justify-between items-center gap-x-2 pt-2">
    <!-- left controls footer (disabled during Live sessions) -->
    <div class="flex flex-row flex-wrap items-center gap-x-6 transition-opacity duration-300"
         [class.pointer-events-none]="liveActive"
         [class.opacity-40]="liveActive"
         [attr.aria-disabled]="liveActive">
      @if (speechEnabled) {
        <i class="p-1 material-icons text-gray-500 hover:invert transition duration-300 cursor-pointer controls-button-size"
          [class.animate-pulse]="speaking"
          pTooltip="Disable Speech Synthesis" tooltipPosition="left" tooltipStyleClass="text-sm"
          showDelay="500"
          (click)="switchSpeechEnabled()">volume_up</i>
      } @else {
        <i class="p-1 material-icons text-gray-500 hover:invert transition duration-300 cursor-pointer controls-button-size"
          pTooltip="Enable Speech Synthesis" tooltipPosition="left" tooltipStyleClass="text-sm"
          showDelay="500"
          (click)="switchSpeechEnabled()">volume_off</i>
      }
        <p-select [(ngModel)]="selectedSpeechLanguage" [options]="speechLanguageOptions"
                  optionLabel="label" optionValue="value" size="small"
                  [disabled]="liveActive"
                  pTooltip="Speech synthesis language" tooltipPosition="right"
                  tooltipStyleClass="text-sm" showDelay="1000"
                  [dt]="{ dropdown: { width: '1.5rem' } }"
                  (onChange)="onSpeechLanguageChange($event)">
        </p-select>
        @if (environment.FEATURE_FLAGS.coso.display_reasoning) {
            <i class="p-1 pi pi-microchip-ai text-gray-500 hover:invert transition duration-300 controls-button-size cursor-pointer"
               pTooltip="Select reasoning effort" tooltipPosition="left"
               tooltipStyleClass="text-sm" showDelay="500"
               (click)="reasoningMenu.toggle($event)"></i>
        }
        @if (!loading && !liveActive) {
            <!--<i class="p-1 pi pi-cloud-upload text-gray-500 hover:invert transition duration-300 cursor-pointer controls-button-size"
                pTooltip="Attach a file" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500"
                (click)="fileUpload.toggle($event)"></i>-->
            <span class="material-symbols-outlined p-1 text-gray-500 hover:invert transition duration-300 cursor-pointer controls-button-size"
                  pTooltip="Attach a file" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500"
                  (click)="fileUpload.toggle($event)">attach_file_add</span>
        } @else {
            <!--<i class="p-1 pi pi-cloud-upload text-gray-500 controls-button-size"
               pTooltip="Attach a file" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500"></i>-->
            <span class="material-symbols-outlined p-1 text-gray-500 controls-button-size"
                  pTooltip="Attach a file" tooltipPosition="left" tooltipStyleClass="text-sm" showDelay="500">attach_file_add</span>
        }
    </div>
    <!-- right controls footer -->
    <div class="flex flex-row gap-x-3 items-center">
      @if(liveModesEnabled) {
        <p-splitbutton [model]="voiceControlMenuItems"
                       [severity]="liveActive ? 'warn' : null"
                       [styleClass]="liveActive ? 'animate-pulse' : ''"
                       [disabled]="loading || (voiceControlMode !== 'dictate' && streamingResponse)"
                       [menuButtonDisabled]="loading || liveActive"
                       [buttonProps]="{ ariaLabel: getVoiceControlTooltip() }"
                       [menuButtonProps]="{ ariaLabel: 'Choose voice control mode' }"
                       [pt]="{ pcDropdown: { root: { class: 'voice-control-caret' } } }"
                       [tooltip]="getVoiceControlTooltip()"
                       [tooltipOptions]="{ tooltipPosition: 'left', tooltipStyleClass: 'text-sm', showDelay: 500 }"
                       appendTo="body"
                       (onClick)="toggleVoiceControl()">
            <ng-template #content>
                @if (voiceControlMode === 'video') {
                    <span class="material-icons flex h-full w-full items-center justify-center text-xl leading-none">videocam</span>
                } @else if (voiceControlMode === 'voice') {
                    <span class="material-icons flex h-full w-full items-center justify-center text-xl leading-none">graphic_eq</span>
                } @else {
                    <span class="material-icons flex h-full w-full items-center justify-center text-xl leading-none"
                          [class.animate-pulse]="listening">mic</span>
                }
            </ng-template>

          <ng-template #dropdownicon>
            <span class="material-icons text-xl leading-none">expand_more</span>
          </ng-template>
        </p-splitbutton>
      } @else {
        <p-button [severity]="listening ? 'warn' : null"
                  [styleClass]="listening ? 'animate-pulse' : ''"
                  [disabled]="loading"
                  [buttonProps]="{ ariaLabel: getVoiceControlTooltip() }"
                  [pTooltip]="getVoiceControlTooltip()"
                  tooltipPosition="left"
                  tooltipStyleClass="text-sm"
                  showDelay="500"
                  (click)="toggleVoiceControl()">
          <ng-template #content>
            <span class="material-icons flex h-full w-full items-center justify-center text-xl leading-none"
                  [class.animate-pulse]="listening">mic</span>
          </ng-template>
        </p-button>
      }
    </div>
  </div>
</div>

<!-- this must be outside any flex container to avoid double gaps -->
<p-menu #reasoningMenu [model]="reasoningEffortOptions" [popup]="true" appendTo="body">
    <ng-template #item let-item>
        <a (click)="onReasoningEffortChange(item.value)"
           class="p-menu-item-link"
           [ngClass]="item.value === selectedReasoningEffort ? 'bg-surface-100 dark:bg-surface-800' : ''">
            <span class="material-symbols-outlined text-base leading-none">cognition_2</span>
            <span>{{ item.label }}</span>
            @if (item.value === selectedReasoningEffort) {
                <i class="pi pi-check ml-auto text-xs"></i>
            }
        </a>
    </ng-template>
</p-menu>


<p-popover #fileUpload>
  <p-fileupload #uploader customUpload="true" (uploadHandler)="uploadHandler($event)"
                [multiple]="true"
                [showUploadButton]="true"
                [accept]="acceptedAttachmentTypes"
                invalidFileTypeMessageSummary="Unsupported file type."
                invalidFileTypeMessageDetail=""
                [auto]="true"
                mode="advanced"
                styleClass="w-[300px] h-[340px] overflow-y-scroll">
    <ng-template #empty>
      <div class="mb-2">Drag and drop a file to here to upload.</div>
      <!--<div class="text-wrap text-xs italic">Supported file types:</div>-->
      <div class="text-wrap text-xs italic">
        @for (type of getSelectedSupportedAttachmentFileTypes(); track type) {
          <div><i class="pi pi-check mr-1 text-green-500" style="font-size: .8rem"></i>{{ type }}</div>
        }
      </div>
    </ng-template>
  </p-fileupload>
</p-popover>

<p-dialog
  header="Add to Knowledge Base"
  [(visible)]="knowledgeBaseDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(920px, 96vw)' }"
  [contentStyle]="{ overflow: 'visible' }"
  appendTo="body">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <label for="knowledge-base-title" class="text-sm font-medium">Title</label>
      <input id="knowledge-base-title"
             type="text"
             pInputText
             [(ngModel)]="knowledgeBaseTitle"
             class="w-full"/>
    </div>

    <div class="flex flex-col gap-2">
      <label for="knowledge-base-language" class="text-sm font-medium">Language</label>
      <p-select id="knowledge-base-language"
                [(ngModel)]="knowledgeBaseLanguage"
                [options]="speechLanguageOptions"
                optionLabel="label"
                optionValue="value"
                class="w-full sm:w-40">
      </p-select>
    </div>

    <div class="flex h-[45vh] min-h-[360px] max-h-[65vh] flex-col gap-2">
      <label for="knowledge-base-markdown" class="text-sm font-medium">Content</label>
      <app-rich-text-editor
        #knowledgeBaseEditor
        id="knowledge-base-markdown"
        [(ngModel)]="knowledgeBaseMarkdown"
        class="flex-1 min-h-0">
      </app-rich-text-editor>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                (click)="closeKnowledgeBaseDialog()" [disabled]="knowledgeBaseSaving"></p-button>
      <p-button label="Save" icon="pi pi-save" (click)="saveKnowledgeBaseEntry()" [loading]="knowledgeBaseSaving"
                [disabled]="knowledgeBaseSaving || !knowledgeBaseTitle.trim() || !knowledgeBaseMarkdown.trim() || !knowledgeBaseLanguage"></p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Save Coso Prompt"
  [(visible)]="cosoPromptDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(920px, 96vw)' }"
  [contentStyle]="{ overflow: 'visible' }"
  appendTo="body">
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <label for="coso-prompt-title" class="text-sm font-medium">Title</label>
      <input id="coso-prompt-title"
             type="text"
             pInputText
             [(ngModel)]="cosoPromptTitle"
             maxlength="512"
             class="w-full"/>
    </div>

    <div class="flex flex-col gap-2">
      <label for="coso-prompt-category" class="text-sm font-medium">Category</label>
      <input id="coso-prompt-category"
             type="text"
             pInputText
             [(ngModel)]="cosoPromptCategory"
             class="w-full"/>
    </div>

    <div class="flex flex-row items-center gap-x-2">
      <p-checkbox inputId="coso-prompt-public" [(ngModel)]="cosoPromptPublic" [binary]="true"></p-checkbox>
      <label for="coso-prompt-public" class="text-sm font-medium">Public</label>
    </div>

    <div class="flex h-[45vh] min-h-[360px] max-h-[65vh] flex-col gap-2">
      <label for="coso-prompt-text" class="text-sm font-medium">Prompt</label>
      <app-rich-text-editor
        #cosoPromptEditor
        id="coso-prompt-text"
        [(ngModel)]="cosoPromptText"
        class="flex-1 min-h-0">
      </app-rich-text-editor>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                (click)="closeCosoPromptDialog()" [disabled]="cosoPromptSaving"></p-button>
      <p-button label="Save" icon="pi pi-save" (click)="saveCosoPromptEntry()" [loading]="cosoPromptSaving"
                [disabled]="cosoPromptSaving || !cosoPromptTitle.trim() || !cosoPromptText.trim()"></p-button>
    </div>
  </ng-template>
</p-dialog>
